import React from 'react';
import { UnifyGeoNamesData } from '../../data/useUnifyContactsGeoNames';
import { FormGrid, SimpleDialog } from '../../../primitives';
import { FormControlsForFields, PlaceholderField } from '../../../schemed';
import { AutoSuggest, AutoSuggestMultiple } from '../../../primitives/AutoSuggests';
import { CRMGeoSuggestionsKeys } from '../../CRMGeoContext';

interface Props {
  data: UnifyGeoNamesData;
}

export const UnifyGeoNamesDialog = (props: Props) => {
  const { data } = props;

  const suggestionsKey = data.item?.field === "geo_country"
    ? CRMGeoSuggestionsKeys.countries
    : data.item?.field === "geo_city"
      ? CRMGeoSuggestionsKeys.cities
      : "";

  return (
    <SimpleDialog
      {...data.dialog}
      dialogTitle="Переименование географии"
      save={() => data.save()}
      saveLabel="переименовать"
      submitOnModEnter
      noFullscreen
      fullWidth
      maxWidth="sm"
      noCancel>
      
      {!!data.item &&
        <>
          <FormGrid columns="1fr 1fr" forceEvenColumns>
            <FormControlsForFields
              data={data.item}
              onChange={(o,c) => data.update(c)}
              schema={data.schema}
              fields={[
                ["field", { controlProps: { autoFocus: true }}],
                [PlaceholderField],
                ["old_values", { control: AutoSuggestMultiple, suggestionsKey: suggestionsKey }],
                ["target_value", { control: AutoSuggest, suggestionsKey: suggestionsKey }],
              ]}
              />

          </FormGrid>
        </>}
    </SimpleDialog>
  );
}
